/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Mode_LabelInputs */

const en_drastic_tech_mode_label = /** @type {(inputs: Drastic_Tech_Mode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode`)
};

const fr_drastic_tech_mode_label = /** @type {(inputs: Drastic_Tech_Mode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode`)
};

const de_drastic_tech_mode_label = /** @type {(inputs: Drastic_Tech_Mode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modus`)
};

const it_drastic_tech_mode_label = /** @type {(inputs: Drastic_Tech_Mode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modalità`)
};

const ru_drastic_tech_mode_label = /** @type {(inputs: Drastic_Tech_Mode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Режим`)
};

const es_drastic_tech_mode_label = /** @type {(inputs: Drastic_Tech_Mode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modo`)
};

const zh_cn2_drastic_tech_mode_label = /** @type {(inputs: Drastic_Tech_Mode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`模式`)
};

const ja_drastic_tech_mode_label = /** @type {(inputs: Drastic_Tech_Mode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`モード`)
};

const hi_drastic_tech_mode_label = /** @type {(inputs: Drastic_Tech_Mode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तरीका`)
};

const pt_pt2_drastic_tech_mode_label = /** @type {(inputs: Drastic_Tech_Mode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modo`)
};

/**
* | output |
* | --- |
* | "Mode" |
*
* @param {Drastic_Tech_Mode_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_mode_label = /** @type {((inputs?: Drastic_Tech_Mode_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Mode_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_mode_label(inputs)
	if (locale === "de") return de_drastic_tech_mode_label(inputs)
	if (locale === "it") return it_drastic_tech_mode_label(inputs)
	if (locale === "ru") return ru_drastic_tech_mode_label(inputs)
	if (locale === "es") return es_drastic_tech_mode_label(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_mode_label(inputs)
	if (locale === "ja") return ja_drastic_tech_mode_label(inputs)
	if (locale === "hi") return hi_drastic_tech_mode_label(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_mode_label(inputs)
	return en_drastic_tech_mode_label(inputs)
});